module.exports = __webpack_public_path__ + "static/media/play_last_card.40fe26c4.png";